import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FormGroup, FormControl, Dropdown } from "react-bootstrap";
import { FiMoreHorizontal, FiUpload } from "react-icons/fi";
import Moment from "react-moment";
import moment from "moment";
import "moment-timezone";
import { Mobile } from "utils/responsive";
import * as groupsActions from "actions/groupsActions";
import { showModal, hideModal, updateModalLoading } from "actions/modalActions";
import Layout from "components/Layout";
import Loading from "components/Loading";
import Modal from "components/Modal";
import TimesNavigationTabs from "components/Times/TimesNavigationTabs";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import { isAdmin, isSupervisor } from "utils/utils";
import { timesService, appService, plansService } from "services";
import DataTable from "components/DataTable";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";
import RelativeDateRangeNav from "components/Shared/RelativeDateRangeNav";
import {
	computeRelativeDateRange,
	DATE_PRESET_CUSTOM,
} from "utils/relativeDatePresets";
import { withTranslation } from "react-i18next";

class TimesWithout extends Component {
	constructor(props) {
		super(props);
		// console.log(props);

		const today = new Date();
		const startDate = moment(today).startOf("month").format("YYYY-MM-DD");
		const endDate = moment(today).endOf("month").format("YYYY-MM-DD");

		this.state = {
			loading: true,
			error: false,
			plan_assignments: [],
			searchEmployee: "",
			startDate,
			endDate,
			filterGroupId: "",
			activeDatePreset: "this_month",
			hasResults: false,
			useWideWithoutTimeTable:
				typeof window !== "undefined" &&
				window.matchMedia("(min-width: 768px)").matches,
		};

		this.abortController = null;
		this.employeeFetchOptions = {};
		this.openExportModal = this.openExportModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	componentDidMount() {
		this.getTimes();
		this.getGroups();

		this._withoutTimeMql = window.matchMedia("(min-width: 768px)");
		this._onWithoutTimeMql = () => {
			this.setState({ useWideWithoutTimeTable: this._withoutTimeMql.matches });
		};
		if (this._withoutTimeMql.addEventListener) {
			this._withoutTimeMql.addEventListener("change", this._onWithoutTimeMql);
		} else {
			this._withoutTimeMql.addListener(this._onWithoutTimeMql);
		}
	}

	componentWillUnmount() {
		if (this._withoutTimeMql && this._onWithoutTimeMql) {
			if (this._withoutTimeMql.removeEventListener) {
				this._withoutTimeMql.removeEventListener(
					"change",
					this._onWithoutTimeMql
				);
			} else {
				this._withoutTimeMql.removeListener(this._onWithoutTimeMql);
			}
		}
		if (this.abortController) {
			this.abortController.abort();
		}
	}

	async getGroups() {
		await this.props.getAllGroups();
	}

	async getTimes() {
		const { searchEmployee, startDate, endDate, filterGroupId } = this.state;

		if (startDate && endDate) {
			// Cancelar petición anterior si existe
			if (this.abortController) {
				this.abortController.abort();
			}

			this.abortController = new AbortController();

			this.setState({ loading: true });

			try {
				const response = await plansService.getPlanAssignments({
					group_id: filterGroupId,
					employee_id: searchEmployee,
					start: startDate,
					end: endDate,
					without_time_registration: true,
					signal: this.abortController.signal, // <-- aquí lo pasas
				});

				if (response.ok) {
					const plan_assignments = response.data;

					let hasResults = false;
					plan_assignments.forEach((pa) => {
						pa.plans.forEach((item) => {
							if (item.assignments.length > 0) hasResults = true;
						});
					});

					this.setState({
						plan_assignments,
						loading: false,
						hasResults,
					});
				} else {
					console.log("Error al cargar los fichajes no realizados:", response);
					this.setState({ error: true, loading: false });
				}
			} catch (err) {
				if (err.name === "AbortError") {
					console.log("Request cancelado");
				} else {
					console.error("Error inesperado:", err);
					this.setState({ error: true, loading: false });
				}
			}
		}
	}

	handleChangeSearch = (event) => {
		this.setState(
			{
				[event.target.id]: event.target.value,
			},
			() => {
				this.getTimes();
			}
		);
	};

	handleEmployeeFilterChange = (idOrNull) => {
		this.setState(
			{
				searchEmployee: idOrNull || "",
			},
			() => {
				this.getTimes();
			}
		);
	};

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;

		if (startDate) startDate = startDate.format("YYYY-MM-DD");

		if (endDate) {
			endDate = endDate.format("YYYY-MM-DD");
		}

		this.setState(
			{
				startDate,
				endDate,
				activeDatePreset: DATE_PRESET_CUSTOM,
			},
			() => {
				this.getTimes();
			}
		);
	};

	handleDatePresetChange = (presetId) => {
		const nextPreset = presetId || DATE_PRESET_CUSTOM;
		const range = computeRelativeDateRange(nextPreset, moment());
		if (!range?.start || !range?.end) return;

		this.setState(
			{
				startDate: range.start.format("YYYY-MM-DD"),
				endDate: range.end.format("YYYY-MM-DD"),
				activeDatePreset: nextPreset,
			},
			() => {
				this.getTimes();
			}
		);
	};

	async handleExport() {
		const { startDate, endDate, filterGroupId, searchEmployee } = this.state;
		const token = await timesService.exportNotDone({
			employee_id: searchEmployee,
			start: startDate,
			end: endDate,
			group_id: filterGroupId,
		});

		if (token.ok) {
			this.openExportModal(token.access_token, "fichajes_no_realizados.xlsx");
		} else {
			this.openAlertModal(
				this.props.t('times.without.exportError'),
				"Error al exportar"
			);
		}
	}

	async downloadExport(token, filename) {
		//console.log(token);
		const response = await appService.getExported(token);
		// console.log(response);

		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = filename;
		a.click();

		this.props.updateModalLoading(false); // Cambiar a no cargando
		this.closeModal(); // cerrar modal de confirmación
	}

	openExportModal(token, filename) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('times.without.exportModalTitle'),
				style: { width: "400px" },
				confirmText: this.props.t('common.download'),
				loadingText: this.props.t('common.downloading'),
				message: this.props.t('times.without.exportModalMessage'),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token, filename);
				},
			},
			"confirm"
		);
	}

	closeModal() {
		this.props.hideModal();
	}

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: "Error" || title,
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	buildWithoutTimeRows = () => {
		const rows = [];
		(this.state.plan_assignments || []).forEach((pa) => {
			const employee = pa.employee;
			(pa.plans || []).forEach((plan) => {
				const assignments = plan.assignments || [];
				if (assignments.length === 0) return;
				assignments.forEach((a, i) => {
					const shiftId = a.shift?.id ?? "s";
					const ubId = a.ubication?.id ?? "u";
					rows.push({
						key: `${employee.id}-${plan.day}-${shiftId}-${ubId}-${i}`,
						day: plan.day,
						employee,
						shiftName: a.shift?.name ?? "",
						ubicationName: a.ubication ? a.ubication.name : "-",
					});
				});
			});
		});
		return rows;
	};

	getWideTableColumns = () => [
		{
			key: "day",
			header: this.props.t('common.day'),
			sortable: false,
			render: (row) => <Moment format="DD/MM/YY">{row.day}</Moment>,
		},
		{
			key: "employee",
			header: this.props.t('common.employee'),
			sortable: false,
			render: (row) => (
				<Link to={`/times/${row.employee.id}/employee`}>
					{row.employee.name} {row.employee.surname}
				</Link>
			),
		},
		{
			key: "shift",
			header: this.props.t('common.shift'),
			sortable: false,
			render: (row) => row.shiftName,
		},
		{
			key: "ubication",
			header: this.props.t('common.location'),
			sortable: false,
			render: (row) => row.ubicationName,
		},
	];

	getContent = () => {
		var { loading, error, useWideWithoutTimeTable } = this.state;

		if (loading) {
			return <Loading />;
		}

		if (error) {
<div className="no-results">{this.props.t('times.without.errorLoading')}</div>
		}

		const flatRows = this.buildWithoutTimeRows();

		return (
			<>
				{!useWideWithoutTimeTable ? (
					<Mobile>
						<div className="table-mobile-container">
							<table className="table table-time-registrations table-mobile">
								<tbody>
									{flatRows.length > 0 ? this.getRows() : this.getEmptyRow()}
								</tbody>
							</table>
						</div>
					</Mobile>
				) : (
					<div className="w-100 without-time-datatable-wrap">
						<DataTable
							tableClassName="table-hover"
							columns={this.getWideTableColumns()}
							rows={flatRows}
							rowKey={(r) => r.key}
							showHeaderSortAffix={false}
							emptyMessage={this.props.t('common.noResults')}
						/>
					</div>
				)}
			</>
		);
	};

	getEmptyRow = () => {
		return (
			<tr>
				<td colSpan="4" className="no-result">
					{this.props.t('common.noResults')}
				</td>
			</tr>
		);
	};

	getRows = () =>
		this.state.plan_assignments.map((pa) => {
			const employee = pa.employee;
			const plans = pa.plans;

			return this.getPlans(employee, plans);
		});

	getPlans = (employee, plans) =>
		plans.map((plan) => {
			const assignments = plan.assignments;
			if (assignments.length > 0)
				return this.getAssignments(employee, assignments, plan);
		});

	getAssignments = (employee, assignments, plan) =>
		assignments.map((a, i) => {
			return (
				<tr key={i}>
					<td>
						<Moment format="DD/MM/YY">{plan.day}</Moment>
					</td>
					<td>
						<Link to={`/times/${employee.id}/employee`}>
							{employee.name} {employee.surname}
						</Link>
					</td>
					<td>{a.shift.name}</td>
					<td>{a.ubication ? a.ubication.name : "-"}</td>
				</tr>
			);
		});

	render() {
		const { groups } = this.props;

		const optionList =
			groups.length > 0 &&
			groups.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		return (
			<>
				<Layout className="page-times page-times-without" context="times">
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">{this.props.t('times.without.title')}</h1>
						</div>

						<div className="heading-actions">
							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() => this.handleExport()}
									>
										<FiUpload className="dropdown-icon" /> {this.props.t('times.without.exportDropdown')}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					<TimesNavigationTabs />

					<div className="subheading">
						<div className="subheading-filters">
						<RelativeDateRangeNav
								startDate={this.state.startDate}
								endDate={this.state.endDate}
								activeDatePreset={this.state.activeDatePreset}
								onDatesChange={this.onDatesChange}
								onPresetChange={this.handleDatePresetChange}
							/>
							<EmployeeSelectSearch
								className={`form-select-user mb-0 ${
									!isAdmin() && !isSupervisor() ? "hidden" : ""
								}`}
								controlId="searchEmployee"
								multiple={false}
								value={this.state.searchEmployee || null}
								onChange={this.handleEmployeeFilterChange}
								fetchOptions={this.employeeFetchOptions}
								placeholder={this.props.t('common.searchEmployee')}
								allLabel={this.props.t('common.allEmployees')}
							/>

							<FormGroup
								className="form-group form-search"
								controlId="filterGroupId"
								style={{ marginBottom: 0 }}
							>
								<FormControl
									type="text"
									placeholder={this.props.t('common.searchPlaceholder')}
									value={this.state.filterGroupId}
									onChange={this.handleChangeSearch}
									as="select"
								>
									<option value="">{this.props.t('common.filterByGroup')}</option>
									{optionList}
								</FormControl>
							</FormGroup>

							
						</div>
					</div>

					{this.getContent()}

					<Modal hideModal={this.props.hideModal} />
				</Layout>
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.employeesReducer,
		...reducers.groupsReducer,
		user: reducers.authReducer.user,
		loading: reducers.plansReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
	getAllGroups: () => dispatch(groupsActions.getAllGroups({ sort: "+name" })),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TimesWithout));
